import React, { Component } from "react";
import posventa from "../../res/iconos/posventa.png";
import pf from "../../res/iconos/pf.png";
import garantia from "../../res/iconos/garantia.png";
import tutoriales from "../../res/iconos/tutoriales.png";
import calcularPx from "../general/calcularPx";

import { Link } from "react-router-dom";

class Atencion extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

  render() {
    const mobile =
      window.innerWidth * 0.8 < 630;
    return (
      <div style={{ }}>
        <img
          src={require("../../res/banners/atencion_" + (mobile ? "mobile":"desktop" ) + ".png")}
          style={{
            position: "relative",
            objectFit: "cover",
            objectPosition: "center",
            width: "100%",
            //height: 368,
            zIndex: -1,
          }}
        />
        <div style={{ width: "100%", height: "7vw" }} />
        <div style={{width: "80%", marginLeft: "auto", marginRight: "auto", display: "flex", justifyContent: "space-between", justifyItems: "center", alignContent: "stretch", gap: 30, flexWrap: "wrap"}}>
          <Link to="/posventa" style={{width: 270, margin: "auto"}}>
            <img className="atencion_boton" src={posventa}/>
            <h2 className="atencion_boton_texto">Servicio Posventa</h2>
          </Link>
          <Link to="/preguntas-frecuentes" style={{width: 270, margin: "auto"}}>
            <img className="atencion_boton" src={pf}/>
            <h2 className="atencion_boton_texto">Preguntas frecuentes</h2>
          </Link>
          <Link to="/atencion-al-cliente/videos" style={{width: 270, margin: "auto"}}>
            <img className="atencion_boton" src={tutoriales}/>
            <h2 className="atencion_boton_texto">Videos tutoriales</h2>
          </Link>
          <Link to="/registrar-producto" style={{width: 270, margin: "auto"}}>
            <img className="atencion_boton" src={garantia}/>
            <h2 className="atencion_boton_texto">Registrá tu producto</h2>
          </Link>
        </div>
        <div style={{width: "100%", height: "7vw"}}/>
    </div>
    );
  }
}

export default Atencion;
